import type { CoworkCompanyEmployeeInput } from "./api"

export function companyEmployeesCsv(
  employees: readonly CoworkCompanyEmployeeInput[],
  headers: readonly [string, string, string],
) {
  const rows = [headers, ...employees.map((employee) => [employee.first_name, employee.last_name, employee.personal_id])]
  return "\uFEFF" + rows.map((row) => row.map(csvCell).join(",")).join("\r\n") + "\r\n"
}

function csvCell(value: string) {
  // Quoting alone does not prevent spreadsheets from interpreting a cell as a formula.
  const text = /^[\t\r\n]|^\s*[=+@-]/.test(value) ? `'${value}` : value
  return `"${text.replace(/"/g, '""')}"`
}
